import { toast } from "sonner";
import { api } from "@/lib/api";

// Saves a finished game's score to the signed-in student's private bests (ignored when signed out).
export const reportScore = (game, label, mode, score) => {
  api.post("/me/game-scores", { game, label, mode, score })
    .then(({ data }) => {
      if (data.new_badge) toast.success("You earned a Game Streak badge! 5 days of games this week.");
      if (data.gotw_badge) toast.success("You earned the Game of the Week badge!");
    })
    .catch(() => {});
};
